module.exports = __webpack_public_path__ + "static/media/Data_insight_en_mo_3-1.0e6f33ee.svg";